module.exports = __webpack_public_path__ + "img/login_webLogo2_.0077913d.png";